import React, { useContext } from "react";
import styled from "styled-components";
import GlobalContext from "../../context/GlobalContext";
import { Link, navigate } from "gatsby";
import NetomniaLogo from "./../../assets/images/svg/netomnia-logo.svg";
import NetomniaLogoWhite from "./../../assets/images/svg/netomnia-logo-white.svg";

const Img = styled.img`
    vertical-align: unset !important;
    width: 100%;
    height: 100%;
    max-width: 193px;
    max-height: 23px;
    object-fit: contain;
    &.auto-width {
        width: 100%;
        height: auto;
        max-width: unset;
        max-height: unset;
    }
`;

const Logo = ({ white = false, auto = false, ...rest}) => {
    const gContext:any = useContext(GlobalContext);

    const resetRegistrationData = () => {
        if (typeof window !== 'undefined') {
            localStorage.removeItem('registrationData')
            gContext?.goResetRegistrationData()
        }
    }
    return (
        <Link to="/" onClick={() => resetRegistrationData()}><Img src={white?NetomniaLogoWhite:NetomniaLogo} className={auto?"auto-width":""} alt="Netomnia" /></Link>
    )
};

export default Logo;